import React from 'react'
import MyComponent from '../Company/Screening/MyComponent'

function Screening() {
  return (
    <>
        <MyComponent />
    </>
  )
}

export default Screening
